// extracted by mini-css-extract-plugin
module.exports = {"criteria-not-met-box":"CriteraNotMet_criteria-not-met-box__k9Sq7"};